import { wait } from '../common'
import Uppy from '@uppy/core'
import DragDrop from '@uppy/drag-drop'
import XHRUpload from '@uppy/xhr-upload'
import ProgressBar from '@uppy/progress-bar'

const slider = document.querySelector('.vp-block-form-offer.layout-slider')
const ajaxWait = 0

let cv = null,
  dom = {}

if (slider) {
  dom = {
    step1: slider.querySelector('#offer-step-1'),
    step2: slider.querySelector('#offer-step-2'),
    step3: slider.querySelector('#offer-step-3'),
    step4: slider.querySelector('#offer-step-4'),
    step5: slider.querySelector('#offer-step-5'),
    step6: slider.querySelector('#offer-step-6'),
    process1: slider.querySelector('#offer-step-1 .process'),
    process2: slider.querySelector('#offer-step-2 .process'),
    process3: slider.querySelector('#offer-step-3 .process'),
    process4: slider.querySelector('#offer-step-4 .process'),
    process5: slider.querySelector('#offer-step-5 .process'),
    reference: slider.querySelector('#offer-reference'),
    email: slider.querySelector('#offer-email'),
    tel: slider.querySelector('#offer-tel'),
    contact_id: slider.querySelector('#offer-contact_id'),
    nom: slider.querySelector('#offer-nom'),
    prenom: slider.querySelector('#offer-prenom'),
    cp: slider.querySelector('#offer-cp'),
    pays: slider.querySelector('#offer-pays'),
    statut: slider.querySelector('#offer-statut'),
    connus: slider.querySelector('#offer-connus'),
    competences: slider.querySelector('#offer-competences'),
    secteurs: slider.querySelector('#offer-secteurs'),
    dropzone: slider.querySelector('.dropzone'),
    uploadMessage: slider.querySelector('.upload-message'),
    uploadOk: slider.querySelector('.upload-ok'),
    uploadFile: slider.querySelector('.upload-file'),
    uploadDelete: slider.querySelector('.upload-delete'),
    rgpd: slider.querySelector('#offer-rgpd'),
    newom: slider.querySelector('#offer-newom'),
    newsletter: slider.querySelector('#offer-newsletter'),
  }

  dom.process1.addEventListener('click', step1)
  dom.process2.addEventListener('click', step2)
  dom.process3.addEventListener('click', step3)
  dom.process4.addEventListener('click', step4)
  dom.process5.addEventListener('click', step5)

  for (const item of slider.querySelectorAll('.back')) {
    item.addEventListener('click', () => {
      window.scrollTo({ top: sliderTop(), left: 0, behavior: 'smooth' })
      slider.dispatchEvent(new Event('prev'))
    })
  }

  dom.step3.querySelector('.options').addEventListener('input', () => {
    dom.competences.value = [
      ...dom.step3.querySelectorAll('.options input:checked'),
    ]
      .map((e) => e.value)
      .join(',')
  })
  dom.step4.querySelector('.options').addEventListener('input', () => {
    dom.secteurs.value = [
      ...dom.step4.querySelectorAll('.options input:checked'),
    ]
      .map((e) => e.value)
      .join(',')
  })

  // upload cv
  const uppy = new Uppy({
    id: 'uppy',
    autoProceed: true,
    restrictions: {
      maxFileSize: 6291456,
      maxNumberOfFiles: 1,
      allowedFileTypes: [
        'application/msword',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/pdf',
      ],
    },
    onBeforeUpload: () => {
      dom.uploadMessage.innerHTML = ''
    },
    debug: false,
  })
    .use(DragDrop, {
      target: dom.dropzone,
      note: dom.dropzone.dataset.uppyNote,
      locale: {
        strings: {
          dropHereOr: dom.dropzone.dataset.uppyLabel,
          browse: dom.dropzone.dataset.uppyBrowse,
        },
      },
    })
    .use(XHRUpload, {
      endpoint: slider.dataset.url,
      formData: true,
    })
    .use(ProgressBar, {
      target: dom.dropzone,
      fixed: false,
      hideAfterFinish: true,
    })

  uppy.setMeta({
    nonce: slider.dataset.nonce,
    action: slider.dataset.action,
    step: 'upload',
  })
  uppy.on('upload-success', (file, response) => {
    // console.log(response.body.data)
    cv = response.body.data
    dom.uploadFile.innerHTML = response.body.data.name
    dom.uploadOk.classList.remove('hidden')
    dom.dropzone.classList.add('hidden')
  })
  uppy.on('upload-error', (file, error, response) => {
    // console.log(error)
    uppy.removeFile(file.id)
    dom.uploadMessage.innerHTML =
      dom.dropzone.dataset.error + `<br>(${response.body.data})`
  })
  uppy.on('error', (error) => {
    console.error(error)
    dom.uploadMessage.innerHTML = "Erreur, le fichier n'est pas valide"
  })
  dom.uploadDelete.addEventListener('click', () => {
    uppy.getFiles().map((file) => {
      uppy.removeFile(file.id)
    })
    cv = null
    dom.uploadFile.innerHTML = ''
    dom.uploadOk.classList.add('hidden')
    dom.dropzone.classList.remove('hidden')
  })

  // init inputs
  dom.email.value = ''
  dom.tel.value = ''
  dom.nom.value = ''
  dom.prenom.value = ''
  dom.cp.value = ''
  dom.pays.value = ''
  dom.competences.value = ''
  dom.secteurs.value = ''
  dom.statut.value = ''
  dom.connus.value = ''
  dom.rgpd.checked = false
  dom.newom.checked = true
  dom.newsletter.checked = true
}

async function step1() {
  if (!validate(dom.step1)) return

  const process = dom.process1
  const message = dom.step1.querySelector('.message')

  const stepData = {
    nonce: slider.dataset.nonce,
    action: slider.dataset.action,
    step: 'contact',
    email: dom.email.value,
    tel: dom.tel.value,
  }

  // start loading
  process.innerHTML = `<span>${process.dataset.loading}<span>${process.dataset.loading}</span></span>`
  process.disabled = true
  await wait(ajaxWait)

  // send
  let response
  try {
    response = await fetch(slider.dataset.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache',
      },
      body: new URLSearchParams(stepData),
    })
  } catch (error) {
    message.innerHTML = 'Pas de réseau disponible'
    return
  }

  // end loading
  process.innerHTML = `<span>${process.dataset.label}<span>${process.dataset.label}</span></span>`
  process.disabled = false

  // http error
  if (!response.ok) {
    switch (response.status) {
      case 400:
        validate(dom.step1)
        break
      default:
        message.innerHTML = `Une erreur est survenue (${response.status} ${response.statusText})`
        break
    }
    return
  }

  const json = await response.json()
  // console.log(json)

  // api error
  message.innerHTML = json.data.message || ''
  if (json.data.kookline_error) {
    message.innerHTML =
      "Une erreur est survenue lors de l'appel à l'api de données."
    return
  }

  // statuts
  if (json.data.autre_statuts) {
    dom.statut.innerHTML = '<option value=""></option>'
    for (const item of json.data.autre_statuts) {
      dom.statut.innerHTML += `<option value="${item.id}">${item.nom}</option`
    }
  }

  // connus
  if (json.data.connus) {
    dom.connus.closest('.field').style.display = 'flex'
    dom.connus.innerHTML = '<option value=""></option>'
    for (const item of json.data.connus) {
      dom.connus.innerHTML += `<option value="${item.id}">${item.nom}</option`
    }
    dom.connus.value = json.data.contact?.connu?.id || ''
  } else {
    dom.connus.closest('.field').style.display = 'none'
  }

  // competences
  if (json.data.competences) {
    const options = dom.step3.querySelector('.options')
    options.innerHTML = ''
    for (const item of json.data.competences) {
      const option = document.createElement('LABEL')
      option.classList.add('option')
      option.innerHTML = `<input type="checkbox" value="${item.id}"><span>${item.nom}</span>`
      options.appendChild(option)
    }
  }

  // secteurs
  if (json.data.secteurs) {
    const options = dom.step4.querySelector('.options')
    options.innerHTML = ''
    for (const item of json.data.secteurs) {
      const option = document.createElement('LABEL')
      option.classList.add('option')
      option.innerHTML = `<input type="checkbox" value="${item.id}"><span>${item.nom}</span>`
      options.appendChild(option)
    }
  }

  // next step
  if (json.data.next) {
    dom.step2.querySelector('.message').innerHTML = json.data.message || ''
    goto(dom.step2)
  } else {
    dom.step2.dataset.status = 'hidden'
    dom.step3.dataset.status = 'hidden'
    dom.step4.dataset.status = 'hidden'
    dom.step5.dataset.status = 'hidden'
    slider.dispatchEvent(new Event('refresh'))
  }
}

function step2() {
  if (!validate(dom.step2)) return

  const message = dom.step2.querySelector('.message')
  message.innerHTML = ''
  goto(dom.step3)
}

function step3() {
  if (!validate(dom.step3)) return

  const message = dom.step3.querySelector('.message')
  message.innerHTML = ''
  goto(dom.step4)
}

function step4() {
  if (!validate(dom.step4)) return

  const message = dom.step4.querySelector('.message')
  message.innerHTML = ''
  goto(dom.step5)
}

async function step5() {
  if (!validate(dom.step5)) return
  if (!validate(dom.step1)) return
  if (!validate(dom.step2)) return
  if (!validate(dom.step3)) return
  if (!validate(dom.step4)) return

  if (!dom.rgpd.checked) {
    dom.serverMessage.innerHTML =
      'Votre consentement à la loi RGPD est nécessaire pour valider votre candidature'
    dom.rgpd.focus()
    return
  }

  const process = dom.step5.querySelector('.process')
  const message = dom.step5.querySelector('.message')
  const stepData = {
    nonce: slider.dataset.nonce,
    action: slider.dataset.action,
    step: 'send',
    id: slider.dataset.id,
    reference: dom.reference.value,
    email: dom.email.value,
    tel: dom.tel.value,
    contact_id: dom.contact_id.value,
    nom: dom.nom.value,
    prenom: dom.prenom.value,
    cp: dom.cp.value,
    pays: dom.pays.value,
    autre_statut: dom.statut.value,
    competences: dom.competences.value,
    secteurs: dom.secteurs.value,
    rgpd: dom.rgpd.checked ? 1 : 0,
    newom: dom.newom.checked ? 1 : 0,
    newsletter: dom.newsletter.checked ? 1 : 0,
  }

  if (cv !== null) {
    stepData.file_tmp_name = cv.tmp_name
    stepData.file_type = cv.type
    stepData.file_name = cv.name
  }

  if (dom.connus.closest('.field').style.display !== 'none') {
    stepData.connus = dom.connus.value
  }

  // start loading
  process.innerHTML = `<span>${process.dataset.loading}<span>${process.dataset.loading}</span></span>`
  process.disabled = true
  await wait(ajaxWait)

  // send
  let response
  try {
    response = await fetch(slider.dataset.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache',
      },
      body: new URLSearchParams(stepData),
    })
  } catch (error) {
    message.innerHTML = 'Pas de réseau disponible'
    return
  }

  // end loading
  process.innerHTML = `<span>${process.dataset.label}<span>${process.dataset.label}</span></span>`
  process.disabled = false

  // http error
  if (!response.ok) {
    switch (response.status) {
      case 400: {
        const json = await response.json()
        console.log(json)
        break
      }
      default:
        message.innerHTML = `Une erreur est survenue (${response.status} ${response.statusText})`
        break
    }
    return
  }

  const json = await response.json()
  // console.log(json)

  // api error
  if (json.data.odoo_error) {
    message.innerHTML =
      "Une erreur est survenue lors de l'appel à l'api de données."
    return
  }

  if (!json.data.response.valid) {
    if (json.data.response.errors?.length > 0) {
      const lines = json.data.response.errors.map((el) => `<div>${el}</div>`)
      message.innerHTML = lines.join('')
    }
  } else {
    dom.step1.dataset.status = 'hidden'
    dom.step2.dataset.status = 'hidden'
    dom.step3.dataset.status = 'hidden'
    dom.step4.dataset.status = 'hidden'
    dom.step5.dataset.status = 'hidden'

    goto(dom.step6)
  }
}

function validate(step) {
  switch (step) {
    case dom.step1:
      for (const item of ['email', 'tel']) {
        if (!dom[item].checkValidity()) {
          step.querySelector('.message').innerHTML = dom[item].dataset.error
          dom[item].focus()
          goto(step)
          return false
        }
      }
      break

    case dom.step2:
      for (const item of ['nom', 'prenom', 'cp', 'pays', 'statut', 'connus']) {
        if (!dom[item].checkValidity()) {
          step.querySelector('.message').innerHTML =
            dom[item].dataset.error || 'erreur'
          dom[item].focus()
          goto(step)
          return false
        }
      }
      break

    case dom.step3:
      if (!dom.competences.checkValidity()) {
        step.querySelector('.message').innerHTML =
          dom.competences.dataset.error || 'erreur'
        goto(step)
        return false
      }
      break

    case dom.step4:
      if (!dom.secteurs.checkValidity()) {
        step.querySelector('.message').innerHTML =
          dom.secteurs.dataset.error || 'erreur'
        goto(step)
        return false
      }
      break

    case dom.step5:
      if (!cv) {
        step.querySelector('.message').innerHTML =
          dom.dropzone.dataset.missing || 'erreur'
        goto(step)
        return false
      }
      if (!dom.rgpd.checked) {
        step.querySelector('.message').innerHTML =
          dom.rgpd.dataset.error || 'erreur'
        goto(step)
        return false
      }
      break
  }

  return true
}

function goto(step) {
  step.dataset.status = ''
  step.dispatchEvent(new Event('navigate'))
}

function sliderTop() {
  return (
    Math.ceil(slider.getBoundingClientRect().top) +
    document.documentElement.scrollTop -
    parseInt(getComputedStyle(slider).getPropertyValue('scroll-margin-top'), 10)
  )
}
